import { Route, Routes, useNavigate } from "react-router-dom";
import { ArrowIcon } from "../../front-end-global-components/assets/assets";
import consentAgreement from "../../front-end-global-components/assets/ConsentAgreement.svg";
import { LogoutCard } from "../Cards/Cards";
import ConnectABDM from "../ConnectABDM/ConnectABDM";
import LogoutModal from "./LogoutModal";
import "./Profile.css";
import { setAuthModes, setTransactionId } from "../../redux/patients/actions";

const Profile = (props) => {
  const navigate = useNavigate();
  const menuItems = [
    {
      name: "ABHA Address",
      description: "View and share your ABHA address",
      path: "/settings/abdmHealthIdCard",
      "data-cy": "SHARE-HEALTH-ID"
    },
    {
      name: "Edit Profile",
      description: "Update the details linked with ABHA Address",
      path: "/settings/editProfile",
      "data-cy": "EDIT-PROFILE"
    },
    {
      name: "ABHA Number",
      description: "Manage ABHA number information",
      path: "/settings/abhaNumber",
      "data-cy": "ABHA-NUMBER"
    },
    {
      name: "Auto-approvals",
      description: "Manage your auto-approval policies",
      path: "/settings/autoApproval",
      "data-cy": "AUTO-APPROVALS"
    },
    {
      name: "Linked Facilities",
      description: "Access your medical records from affiliated clinics",
      path: "/settings/linkedFacilities",
      "data-cy": "LINKED-FACILITIES"
    },
    {
      name: "OPD Token History",
      description: "Manage check-in and appointment tokens",
      path: "/settings/tokenHistory",
      "data-cy": "TOKEN-HISTORY"
    },
    {
      name: "Reset Password",
      description: "Update the password linked with ABHA address",
      path: "/settings/resetPassword",
      "data-cy": "RESET-PASSWORD"
    }
  ];

  return (
    <div className="display-flex flex-grow-1 flex-direction-column profile-setting-height">
      <div className="inherit-parent-height padding-horizontal-larger">
        {props.abdmLoggedIn && (
          <>
            {props.isUserAgreed ? (
              menuItems.map((item, index) => (
                <div
                  key={index}
                  className="display-flex flex-grow-1 flex-align-items-center padding-top-large"
                  data-cy={item["data-cy"]}
                >
                  <div
                    className="flex-grow-1 flex-direction-column display-flex font-color-secondary cursor-pointer"
                    onClick={() => {
                      navigate(item.path);
                    }}
                  >
                    <span className="font-size-medium font-family-gilroy-regular">
                      {item.name}
                    </span>
                    <span className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small">
                      {item.description}
                    </span>
                  </div>
                  <ArrowIcon />
                </div>
              ))
            ) : (
              <div className="inherit-parent-height overflow-y-auto flex-place-children-page-center padding-large">
                <img src={consentAgreement} alt="Consent Agreement" />
                <div className="padding-top-large font-family-gilroy-medium font-color-secondary font-size-large">
                  Consent agreement
                </div>
                <div className="font-color-tertiary font-size-large text-align-center padding-top-default">
                  To access all features, agree our{" "}
                  <span
                    className="font-color-primary cursor-pointer"
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    consent form
                  </span>{" "}
                  on the home screen.
                </div>
              </div>
            )}
          </>
        )}

        {!props.abdmLoggedIn && (
          <div className="inherit-parent-height flex-justify-content-center flex-align-items-center">
            <ConnectABDM
              connectOnClick={() => {
                setAuthModes(null);
                setTransactionId(null);
                navigate("/abdm/login");
              }}
            />
          </div>
        )}
      </div>

      <LogoutCard
        onclick={() => {
          navigate("/settings/logout");
        }}
      />

      <Routes>
        <Route
          path="logout"
          element={
            <LogoutModal
              onClose={() => {
                navigate("/settings");
              }}
              logout={props.logout}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default Profile;
